import DatabaseService from 'services/DatabaseService.js';
import {SET_CARDS,
        REPLACE_CARD,
        ADD_CARD,
        ADD_CARDS} from 'actions/types';
import {isCardsListLoaded,
        getCards,
        getCard}  from 'reducers/cards.js';

//Action Creators
export const setCards = (cards) => {
    return { type:SET_CARDS, cards:cards};
}
export const addCard = (card) => {
    return { type:ADD_CARD, card:card};
}
export const replaceCard= (oldCard, card) => {
    return { type:REPLACE_CARD, oldCard, card};
}
export const addCards = (cards) => {
    return { type:ADD_CARDS, cards:cards};
}


const getCardPseudoId = (card) => {
    if(card.survey) {
        return "survey" + card.survey.id;
    } else if (card.leaderboard) {
        return "leaderboard" + card.leaderboard.id;
    } else if (card.season) {
        return "season" + card.season.id;
    }
    return null;
}

//helpers
export const processCards = (dispatch, cards) => {
    cards = cards.map(c => ({id:getCardPseudoId(c), ...c}));
    dispatch(setCards(cards));
}


//Thunks
export const fetchCards = (force) => (dispatch, getState) => {
    if(!force) {
        var state = getState();
        if(isCardsListLoaded(state.cards)) {
            return Promise.resolve(getCards(state.cards));
        }
    }

    return new Promise(function(resolve, reject) {
        DatabaseService.getTimeline({cards:true}).then( //timeline
            function(result) {
                console.log('fetchCards', result);
                var cards = result.cards;
                processCards(dispatch, cards);
                resolve(cards); 
            },
            function(error) {
                console.error(error);
                reject(error); 
            });
    });
}







// WEBPACK FOOTER //
// ./src/actions/cards.js